export const LAST_INCIDENTS_TAB_VALUE = 'LAST_INCIDENTS'
export const LAST_SHIPPINGS_TAB_VALUE = 'LAST_SHIPPINGS'
